import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    fee: 'Shine Commission',
    feeType: {
      ACCOUNT_IRREGULAR_USE: '',
      ADDITIONAL_TRANSFER:
        'You hit your free transfers monthly limit.' +
        ' Additional transfers are charged {0} (VAT excluded) each.',
      CARD_ATM_EURO:
        'We charge {0} when you pay by credit card inside the euro zone.',
      CARD_ATM_NON_EURO:
        'We charge {0} when you pay by credit card outside the euro zone.',
      CARD_PAYIN_EURO:
        'We charge {0} when you receive a payment by credit card in the euro zone',
      CARD_PAYIN_NON_EU:
        'We charge {0} when you receive a payment by credit card outside the European Union',
      CARD_PAYIN_NON_EURO:
        'We charge {0} when you receive a payment by credit card in another currency in the European Union',
      CARD_PAYMENT_DISPUTE: '',
      CARD_PAYMENT_IRREGULARITY: '',
      CARD_PAYOUT_EURO: '',
      CARD_PAYOUT_NON_EU:
        'We charge {0} when you pay by credit card outside the euro zone.',
      CARD_PAYOUT_NON_EURO:
        'We charge {0} when you pay by credit card outside the euro zone.',
      CARD_REPLACEMENT_BASIC: '',
      CARD_REPLACEMENT_PREMIUM: '',
      CASH_DEPOSIT:
        'You hit your monthly free deposit limit.' +
        ' We charge a commission of {0} on the deposited amount plus tax, debited immediately at the time of the additional deposit.',
      CHECK:
        'You hit your monthly free check limit.' +
        ' Additional checks are charged {0} (VAT excluded) each.',
      CHECK_INVALID:
        'We charge {0} (VAT excluded) when a check has been incorrectly filled out.',
      CHECK_REFUSED: 'We charge {0} (VAT excluded) when a check is rejected.',
      DIRECT_DEBIT_CANCELLATION: '',
      FREE: '',
      SWIFT_TRANSFER_PAYIN:
        'We charge a management fee of {0} (VAT excluded) when you receive a transfer through the Swift network.',
    },
    feeWithoutVat: '{0} VAT excl.',
    feeWithVat: '{0} VAT incl.',
  },
  fr: {
    fee: 'Commission Shine',
    feeType: {
      ACCOUNT_IRREGULAR_USE: '',
      ADDITIONAL_TRANSFER:
        'Vous avez atteint votre limite de virements et prélèvements gratuits mensuels.' +
        ' Les virements additionnels sont facturés {0} HT.',
      CARD_ATM_EURO:
        'Nous facturons une commission de {0} lorsque vous retirez à un distributeur au sein de la zone euro.',
      CARD_ATM_NON_EURO:
        'Nous facturons une commission de {0} lorsque vous retirez à un distributeur en dehors de la zone euro.',
      CARD_PAYIN_EURO:
        'Nous facturons une commission de {0} lorsque vous recevez un paiement par carte en zone euro.',
      CARD_PAYIN_NON_EU:
        'Nous facturons une commission de {0} lorsque vous recevez un paiement par carte hors Union Européenne.',
      CARD_PAYIN_NON_EURO:
        'Nous facturons une commission de {0} lorsque vous recevez un paiement par carte dans une autre devise de l’Union Européenne',
      CARD_PAYMENT_DISPUTE: '',
      CARD_PAYMENT_IRREGULARITY: '',
      CARD_PAYOUT_EURO: '',
      CARD_PAYOUT_NON_EU:
        'Nous facturons une commission de {0} lorsque vous payez par carte en dehors de la zone euro.',
      CARD_PAYOUT_NON_EURO:
        'Nous facturons une commission de {0} lorsque vous payez par carte en dehors de la zone euro.',
      CARD_REPLACEMENT_BASIC: '',
      CARD_REPLACEMENT_PREMIUM: '',
      CASH_DEPOSIT:
        'Vous avez atteint votre limite de dépôts mensuels inclus dans votre abonnement.' +
        ' Nous facturons une commission de {0} HT du montant déposé, prélevée directement au moment du dépôt additionnel.',
      CHECK:
        'Vous avez atteint votre limite de chèques mensuels.' +
        ' Les chèques additionnels sont facturés {0} HT.',
      CHECK_INVALID:
        'Nous facturons {0} HT quand un chèque a été mal renseigné.',
      CHECK_REFUSED: 'Nous facturons {0} HT quand un chèque est rejeté.',
      DIRECT_DEBIT_CANCELLATION: '',
      FREE: '',
      SWIFT_TRANSFER_PAYIN:
        'Nous facturons des frais de gestion de {0} HT lorsque vous recevez un virement passant par le réseau Swift. ',
    },
    feeWithoutVat: '{0} HT',
    feeWithVat: '{0} TTC',
  },
} as const);

export default locales;
